import { ServiceType } from '../types';

export const services: ServiceType[] = [
  // FRAUEN
  {
    id: 1,
    name: 'Ganzkörper',
    price: '219€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 2,
    name: 'Oberkörper',
    price: '159€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 3,
    name: 'Gesicht',
    price: '45€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 4,
    name: 'Arme',
    price: '89€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  { 
    id: 5,
    name: 'Achsel',
    price: '59€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 6,
    name: 'Arme & Achsel',
    price: '110€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 7,
    name: 'Intim',
    price: '89€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 8,
    name: 'Bikini',
    price: '59€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 9,
    name: 'Beine',
    price: '89€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 10,
    name: 'Beine & Intim',
    price: '159€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 11,
    name: '4er KUR Ganzkörper',
    price: '776€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },
  {
    id: 12,
    name: '8er KUR Ganzkörper',
    price: '1533€',
    category: 'dauerhaufte haarentfernung',
    gender: 'frauen'
  },

  // HERREN
  {
    id: 101,
    name: 'Oberkörper',
    price: '219€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 102,
    name: 'Gesicht & Bart',
    price: '69€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 103,
    name: 'Arme',
    price: '99€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 104,
    name: 'Achsel',
    price: '69€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 105,
    name: 'Arme & Achsel',
    price: '149€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 106,
    name: 'Brust & Bauch',
    price: '115€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 107,
    name: 'Rücken',
    price: '115€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 108,
    name: 'Brust, Bauch & Rücken',
    price: '169€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 109,
    name: '4er KUR Oberkörper (Ersparnis 100€)',
    price: '776€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },
  {
    id: 110,
    name: '8er KUR Oberkörper (Ersparnis 219€)',
    price: '1533€',
    category: 'dauerhaufte haarentfernung',
    gender: 'maenner'
  },

  // Gesichtsbehandlung by Dr. Grandel
  // Hydro 
  {
    id: 111,
    name: 'Hydro Treatment Classic 60 min',
    price: '99€',
    category: 'skincare'
  },
  {
    id: 112,
    name: 'Hydro Treatment Deluxe 90 min',
    price: '135€',
    category: 'skincare'
  },
  // Glow Treatment
  {
    id: 113,
    name: 'Glow Treatment Classic 60 min',
    price: '125€',
    category: 'skincare'
  },
  {
    id: 114,
    name: 'Glow Treatment Deluxe 90 min',
    price: '145€',
    category: 'skincare'
  },
  // Fine Treatment
  {
    id: 115,
    name: 'Fine Treatment Classic 60 min',
    price: '125€',
    category: 'skincare'
  },
  {
    id: 116,
    name: 'Fine Treatment Deluxe 90 min',
    price: '145€',
    category: 'skincare'
  },
  // Lift Treatment
  {
    id: 117,
    name: 'Lift Treatment Classic 60 min',
    price: '99€',
    category: 'skincare'
  },
  {
    id: 118,
    name: 'Lift Treatment Deluxe 90 min',
    price: '135€',
    category: 'skincare'
  },
  // Relax Treatment
  {
    id: 119,
    name: 'Relax Treatment Classic 60 min',
    price: '99€',
    category: 'skincare'
  },
  {
    id: 120,
    name: 'Relax Treatment Deluxe 90 min',
    price: '135€',
    category: 'skincare'
  },
  // Extras
    {
    id: 121,
    name: 'Lichtherapie',
    price: '+ 10€',
    category: 'extras'
  },
  {
    id: 122,
    name: 'Augenbrauenkorrektur',
    price: '+ 20€',
    category: 'extras'
  },
  {
    id:123,
    name: 'Aquafacial 90 min',
    price: '145€',
    category: 'skincare'
  },
  {
    id:124,
    name: 'Wimpernlifting',
    price: '45€',
    category: 'lash & browlifting'
  },
  {
    id:125,
    name: 'Browlifting',
    price: '45€',
    category: 'lash & browlifting'
  },
  {
    id:126,
    name: 'Wimpern- & Browlifting',
    price: '80€',
    category: 'lash & browlifting'
  },
  {
    id:127,
    name: 'Microneedling 60 min 1er Kur',
    price: '139€',
    category: 'all'
  },
  {
    id:128,
    name: 'Microneedling 60 min 3er Kur',
    price: '359',
    category: 'all'
  },
  {
    id:128,
    name: 'Microneedling 60 min 6er Kur',
    price: '699€',
    category: 'all'
  },
  {
    id:129,
    name: 'Aquafiacial & Microneedling 90 min',
    price: '199€',
    category: 'skincare',
    belongs_to: 'skincare'
  },
  {
    id:130,
    name: 'Aquafiacial & BB Glow',
    price: '199€',
    category: 'skincare',
    belongs_to: 'skincare'
  },
  {
    id:131,
    name: 'Microneedling & BB Glow 90min',
    price: '249€',
    category: 'skincare',
    belongs_to: 'skincare'
  },
  {
    id:132,
    name: 'Aquafiacial & Microneedling & BB Glow 120 min',
    price: '339€',
    category: 'skincare',
    belongs_to: 'skincare'
  },
  {
    id:133,
    name: 'BB Glow 60 min 1er Kur',
    price: '139€',
    category: 'all',
    belongs_to: 'skincare'
  },
  {
    id:134,
    name: 'BB Glow 60 min 3er Kur',
    price: '359€',
    category: 'all'
  },
];
